import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { BookingInvoice, FullPaymentInvoice, IDType, PSRole, PvtSellRequest, PvtSellResponse, Receipt } from "../../../apis/privatesell/enitites";
import { Redirect } from "react-router";
import PrivateSellHeader from "../Component/PrivateSellHeader";
import FormSection from "../../../components/Form/FormSection";
import FormRow from "@eres/forms-web/FormRow";
import CurrencyInputField from "@eres/forms-web/CurrencyInputField";
import { NonZeroValidator } from "@eres/forms/validator/NonZeroValidator";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import InvoiceDetail from "../Component/View/Invoice";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import { hideLoading, showErrorMessage, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { showTerms } from "../../../apis/privatesell/api";
import { openPayment } from "@my-dld/utils/Utils";
import PaymentFrame from "../../TabuRequest/PaymentFrame";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { privateSellApi } from "../../../apis/privatesell";
import MessageActionButtonPopup from "@my-dld/components/Popup/MessageActionButtonPopup";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";

interface Props extends RoutedViewProps {
}

const getInvoiceType = [ BookingInvoice, FullPaymentInvoice ];

interface State {
	request?: PvtSellRequest;
	askingPrice?: string;
	invoiceType?: IDType;
	canBook?: boolean;
	isAccept: boolean;
	paymentUrl?: string;
	paymentMessage?: string;
	paymentResponse?: PvtSellResponse;
}

export default class BookingPayment extends Component<Props, State> {
	payment = React.createRef<PaymentFrame>();

	constructor( props: Props ) {
		super( props );
		const state = props.location.state;
		let ps: Partial<State> = {};
		ps.canBook = false;
		if ( state && state.result ) {
			ps.paymentResponse = state.result;
			ps.request = state.result.request ? state.result.request : undefined;
			ps.askingPrice = ps.request?.sellRequestInfo!.askingPrice;
			ps.canBook = state.canBook ?? false;
		}
		if ( state ) {
			ps.canBook = state.canBook;
		}
		this.state = {
			...ps,
			invoiceType: ps.canBook === false ? FullPaymentInvoice : undefined,
			isAccept: false,
		};
		this.onPaymentBack = this.onPaymentBack.bind( this );
	}

	render() {
		const { request, invoiceType, paymentUrl, paymentMessage, canBook } = this.state;
		if ( !request ) {
			return <Redirect to={ "/" }/>;
		}
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		return <PrivateSellHeader role={ PSRole.BUYER } request={ request! }>
			<div className={ "col-md-12 property-details content-section" }>
				<div className={ "tender-registration-form" }>
					<FormSection title={ Strings.payment_information }>
						<FormRow>
							<CurrencyInputField
								{ ...filedProps }
								containerClassName={ "form-group col-4" }
								required={ true }
								id={ "askingPrice" }
								disabled={ true }
								label={ Strings.asking_price }
								valueValidators={ NonZeroValidator }/>
						</FormRow>
						<FormRow>
							<RadioInputField
								{ ...filedProps }
								containerClassName={ "form-group col-4" }
								required={ true }
								id={ "invoiceType" }
								toIdentifier={ IdExtractor }
								label={ Strings.select_amount } items={ canBook ? getInvoiceType : [ getInvoiceType[ 1 ] ] }
							/>
						</FormRow>
					</FormSection>
				</div>
			</div>
			{
				invoiceType && <>
					<InvoiceDetail
						invoiceType={ invoiceType } referenceNumber={ request.bookingRequestInfo.referenceNumber! }
						updatePaymentLink={ this.onUpdatePaymentLink }/>
					<div className={ "col-12 mb-2" }>
						<div className="d-flex pb-2">
							<CheckBoxField
								errorManager={ defaultErrorManager }
								holder={ StateHolder.buildStateHolder( this ) }
								id={ "isAccept" }
								label={ Strings.i_agree_to_the }
								/>
							<a className="btn-link ms-1" onClick={ this.onShowTerms }>{ Strings.terms_and_conditions }</a>
						</div>
					</div>
					<div className={ "col-12" }>
						{
							paymentUrl && <button onClick={ this.payNow } className="btn btn_1 btn_style1" type="submit">
								{ Strings.pay_now }
							</button>
						}
						<a onClick={ this.backToPage } className="btn btn-grey btn_style1 ms-2 me-2">{ Strings.close_label }</a>
					</div>
				</>
			}
			{
				paymentMessage &&
				<MessageActionButtonPopup message={ paymentMessage } onAction={ this.onPaymentBack } onCancel={ this.onPaymentBack }/>
			}
		</PrivateSellHeader>;
	}

	backToPage = () => {
		this.props.history.goBack();
	};

	onUpdatePaymentLink = ( link: string ) => {
		this.setState( { paymentUrl: link } );
	};

	payNow = () => {
		if ( this.state.isAccept && this.state.paymentUrl ) {
			this.openPaymentUrl( this.state.paymentUrl );
		} else {
			showMessage( Strings.please_confirm_payment );
		}

	};

	private onShowTerms = () => {
		this.setState( {
			isAccept: true,
		}, showTerms );
	};

	private trackPSEvent( action: string, extra?: any, ) {
		const { request, invoiceType } = this.state;
		let param = {
			...extra,
			bookingRef: request?.bookingRequestInfo!.referenceNumber + "",
			invoiceType: invoiceType === BookingInvoice ? BookingInvoice : FullPaymentInvoice,
		};
		trackEventWithData( "PrivateSell", action, param );
	}

	private onPaymentBack() {
		const { request } = this.state;
		JQModal( "message_action" ).hide( () => {
			replaceNavigate( `/${ request?.bookingRequestInfo!.referenceNumber }`,
				undefined, {
					result: this.state.paymentResponse,
					role: PSRole.BUYER
				} );
		} );
	}

	private onPaymentSuccess( ref: string ) {
		// const { request } = this.state;
		// this.trackPSEvent("PaymentSuccess", ref);
		// this.context.setData("MSCharges", undefined);
		// replaceNavigate(`/mydld/mollak_service_charges/success/${ property.propertyTypeId }/${ property.propertyId }/${ ref }`,
		//     undefined, { property: property });
	}

	private openPaymentUrl( paymentUrl: string ) {
		let win: Window | null = null;
		let handled = false;
		window.name = "MyDLD";
		const listener = ( event: any ) => {
			const data: any = event.data;
			if ( data ) {
				const type = data.type;
				if ( type === "eres_pay" ) {
					if ( this.payment.current )
						this.payment.current.dismiss();
					this.setState( { paymentUrl: undefined } );
					window.removeEventListener( "message", listener );
					window.open( "", "MyDLD" )?.focus();
					if ( win ) {
						handled = true;
						if ( win.close )
							win.close();
						window.focus();
					}
					setTimeout( () => {
						hideLoading();
						if ( data.data ) {
							const rsp = data.data;
							const status: string | undefined = data.data.PaymentStatus ?? data.data.paymentStatus;
							if ( status && status.toLowerCase() === "completed" ) {
								this.onPaymentComplete( rsp );
							} else {
								this.trackPSEvent( "PaymentFailed" );
								let message = Strings.payment_failed;
								if ( rsp && rsp.error != undefined ) message = message + "\n" + rsp.error;
								this.setState( { paymentMessage: message }, JQModal( "message_action" ).show );
							}
							// if ( !StringUtil.isEmptyStringOrNull(data.data.error) ) {
							//     this.trackPSEvent("PaymentFailed");
							//     showErrorMessage(data.data.error);
							// } else if ( !StringUtil.isEmptyStringOrNull(data.data.refNumber) ) {
							//     this.onPaymentSuccess(data.data.refNumber);
							// }
						}
					}, 1 );
				}
			}
		};
		window.addEventListener( "message", listener, false );
		if ( window.AppInfo.usePaymentFrame ) {
			this.setState( {
				paymentUrl: paymentUrl
			} );
		} else {
			win = openPayment( paymentUrl );
			if ( win ) {
				showLoading();
				const pollTimer = window.setInterval( function () {
					if ( !handled && win!.closed ) {
						window.clearInterval( pollTimer );
						window.removeEventListener( "message", listener );
						hideLoading();
					}
				}, 200 );
			} else {
				console.log( "no window" );
				showErrorMessage( "Enable Popup window to continue" );
			}
		}
	}

	private onPaymentComplete( rsp: any ) {
		const { request, invoiceType } = this.state;
		let param = {
			bookingRef: request?.bookingRequestInfo!.referenceNumber + "",
			invoiceType: invoiceType === BookingInvoice ? BookingInvoice : FullPaymentInvoice,
		};
		showLoading();
		const apiHandler = ( response: any ) => {
			hideLoading();
			let receipt: Receipt | undefined = undefined;

			if ( response.receipts && response.receipts.length > 0 ) {
				let receipts: Receipt[] = response.receipts;
				receipt = receipts.find( x => x.invoiceType.identity === invoiceType?.Id );
				if ( receipt ) {
					rsp.receipt = receipt;
					this.trackPSEvent( "PaymentSuccess", { transactionID: receipt.receiptNumber } );
				}
			}
			if ( response.certificate ) {
				rsp.certificate = response.certificate;
			}
			this.setState( { paymentResponse: response, paymentMessage: Strings.mollak_payment_success }, JQModal( "message_action" ).show );

		};

		const exHandler = ( reason: any ) => {
			hideLoading();
			if ( reason && reason.type && reason.type === "ValidationError" ) {
				showMessage( Strings.system_error + "\n" + reason.message );
				this.trackPSEvent( "PaymentFailed", { error: Strings.system_error + "-" + reason.message } );
			} else {
				this.trackPSEvent( "PaymentFailed", { error: reason.toString() } );
				showMessage( reason.toString() );
			}
		};
		privateSellApi.getSellRequestByRef( param.bookingRef ).then( apiHandler ).catch( exHandler );
	}
}
